<template>
  <v-card class="ma-6">
    <v-card-title>
      <v-icon color="primary" class="mr-6">camera_alt</v-icon>
      Snapshots
      <div class="flex-grow-1"></div>
      <v-text-field color="green" v-model="search" append-icon="search" label="Search by any field" single-line
        hide-details></v-text-field>
    </v-card-title>

    <v-data-table dense :headers="headers" :options.sync="options" @click:row="rowClicked" :items="items"
      :server-items-length="totalItems" :footer-props="{
        itemsPerPageOptions: [10, 20, 100, 500, -1]
      }" :search="search" loading-text="Loading...please wait" :loading="loading">

      <template v-slot:item.scanEndDateTime="{ item }">
        {{ item.scanEndDateTime | toFriendlyDate('In Progress') }}
      </template>
      <template v-slot:item.activeWeightedAvgPrice="{ item }">
        {{ item.activeWeightedAvgPrice | toCurrency(0) }}
      </template>
      <template v-slot:item.activeMinPrice="{ item }">
        {{ item.activeMinPrice | toCurrency(0) }}
      </template>
      <template v-slot:item.maxPrice="{ item }">
        {{ item.maxPrice | toCurrency(0) }}
      </template>


    </v-data-table>
  </v-card>

</template>

<script>
import { SnapshotsService } from '../services/api/snapshots';
import _ from "lodash";

const apiSnapshots = new SnapshotsService();

export default {
  data() {
    return {
      totalItems: 0,
      items: [],
      loading: true,
      options: {},

      search: '',

      headers: [
        // HACK:  use ' d-none' (note the leading space) to hide the column.
        { text: 'ID', value: 'id', hidden: true, align: ' d-none' },
        { text: 'Marketplace', value: 'marketplace.name', sortable: false },
        { text: 'Identifier', value: 'inputIdentifier', sortable: false },
        { text: 'Date / Time', value: 'scanEndDateTime' },
        { text: 'Listings', value: 'activeListingCount', align: 'end' },
        { text: 'Total Qty', value: 'activeTotalQty', align: 'end' },
        { text: 'Weighted Avg $', value: 'activeWeightedAvgPrice', align: 'end' },
        { text: 'Min $', value: 'activeMinPrice', align: 'end' },
        { text: 'Max $', value: 'maxPrice', align: 'end' },
      ],
    }
  },

  watch: {
    options: {
      handler() {
        this.loadItems()
      },
      deep: true,
    },
    // Watch for changes to the search text.
    search: function () {
      this.debouncedloadItems();
    }
  },

  created: function () {
    this.debouncedloadItems = _.debounce(this.loadItems, 500);
  },

  methods: {
    loadItems() {
      this.loading = true
      return new Promise((resolve, reject) => {
        this.getSnapshots();
      })
    },

    getSnapshots() {
      this.loading = true;

      // Clear our list so the loading text will be shown.
      this.items = [];

      // Set up our search, sort, and paging parameters
      const search = {
        searchText: this.search,

        // If there's a sortBy field set, then use it; otherwise use a reasonable default.
        sortOrderField: this.options.sortBy.length == 1 ? this.options.sortBy[0] : "ScanBeginDateTime",
        // If there's no sortDesc defined, sort by desc.  Otherwise sort by the value.
        sortDirection: this.options.sortDesc.length == 0 ? "desc" : (this.options.sortDesc[0] ? "desc" : "asc"),
        itemsPerPage: this.options.itemsPerPage,
        itemsToSkip: this.options.itemsPerPage * (this.options.page - 1),
      }

      // Get the list of items from the API.
      apiSnapshots.getSnapshots(search).then((data) => {
        this.items = data.items
        this.totalItems = data.totalItemCount;
      });

      this.loading = false;
    },

    // When a row is clicked, go to the detail page.
    rowClicked(item) {
      this.$router.push({ name: "Snapshot", params: { id: item.id } });
    },
  },
}
</script>